import { useI18n } from '@runtime/core/i18n/i18n'
import { DEFAULT_POSTER_THEME_ID } from '@runtime/core/theme/posterThemes'
import ActivityCard from '@/components/navigation/ActivityCard'
import { homeActivityImages } from '@/routes/home/homeActivityImages'
import { trackHomeTileClick } from '@/routes/home/homeMetrics'
import HomePosterContext, { type HomePlayProps } from './HomePosterContext'
import HomeSecondaryActivities from './HomeSecondaryActivities'
import styles from './HomePlay.module.scss'
export default function HomePlay(props: HomePlayProps) {
  const { t } = useI18n()
  const ready = props.state.status === 'ready'
  const themeId =
    props.state.status === 'ready'
      ? props.state.cfg.id || DEFAULT_POSTER_THEME_ID
      : DEFAULT_POSTER_THEME_ID
  return (
    <section className={styles.play} aria-labelledby="home-play-title">
      <HomePosterContext {...props} />
      <div className={styles.primary}>
        {(['strategy', 'puzzle'] as const).map(id => (
          <ActivityCard
            key={id}
            to={'/' + id}
            title={t('common.playNavigation.' + id)}
            description={t('home.welcome.' + id + 'Desc')}
            cta={id === 'strategy' ? t('home.welcome.play') : t('home.welcome.choose')}
            images={homeActivityImages(themeId, id)}
            disabled={!ready}
            testId={'home-play-' + id}
            onClick={() => trackHomeTileClick(id, '/' + id)}
          />
        ))}
      </div>
      <HomeSecondaryActivities ready={ready} />
    </section>
  )
}
